// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__34ptd","row":"Node_row__3Th7q","label":"Node_label__67-7f","footer":"Node_footer__grIs2"};